import { render, staticRenderFns } from "./LeaseDetails.vue?vue&type=template&id=226041d3&scoped=true"
import script from "./LeaseDetails.vue?vue&type=script&lang=js"
export * from "./LeaseDetails.vue?vue&type=script&lang=js"
import style0 from "./LeaseDetails.vue?vue&type=style&index=0&id=226041d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226041d3",
  null
  
)

export default component.exports